import { LeverageType } from 'src/services/order/create-leverage-order';
import { Pair } from 'src/services/token/get-active-pair';
import {
  SET_CURRENT_PAIR,
  SET_FAVORITE_PAIR,
  SET_LIST_PAIR,
  SET_LIST_TOKEN,
  SET_PAIR_LEVERAGE,
  SET_PAIR_USER_DATA,
  SET_SELECTED_SIZE,
  SET_TRADING_MODE,
  SET_ORDER_FORM_PAIR_DATA,
} from '../constants/pairs';
import { OrderFormData, PairUserData } from 'src/types/pair';

interface LeveragePair {
  [pair: string]: number;
}
interface PairState {
  currentPair: Pair;
  listPair: Pair[];
  listToken: string[];
  selectedSize: number | null;
  pairLeverages: LeveragePair; // leverage per pair
  tradingMode: {
    [pair: string]: LeverageType; // leverage type per pair
  };
  favoritePairs: string[];
  pairUserData: {
    [pair: string]: PairUserData;
  };
  orderFormData: OrderFormData;
}

const initialState: PairState = {
  currentPair: {} as Pair,
  listPair: [],
  listToken: [],
  selectedSize: null,
  pairLeverages: {},
  tradingMode: {},
  favoritePairs: [],
  pairUserData: {},
  orderFormData: {},
};

export const pairReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_CURRENT_PAIR:
      return {
        ...state,
        currentPair: action.payload,
      };
    case SET_LIST_PAIR:
      return {
        ...state,
        listPair: action.payload,
      };
    case SET_LIST_TOKEN:
      return {
        ...state,
        listToken: action.payload,
      };
    case SET_SELECTED_SIZE:
      return {
        ...state,
        selectedSize: action.payload,
      };
    case SET_PAIR_LEVERAGE:
      return {
        ...state,
        pairLeverages: {
          ...state.pairLeverages,
          [action.payload.pair]: action.payload.leverage,
        },
      };

    case SET_TRADING_MODE:
      return {
        ...state,
        tradingMode: {
          ...state.tradingMode,
          [action.payload.pair]: action.payload.mode,
        },
      };
    case SET_FAVORITE_PAIR:
        const isAlreadyFavorite = (state.favoritePairs ?? []).some(
          (pairId) => pairId === action.payload
        );
        return {
          ...state,
          favoritePairs: isAlreadyFavorite
            ? (state.favoritePairs ?? []).filter((pairId) => pairId !== action.payload)
            : [...(state.favoritePairs ?? []), action.payload],
        };
    case SET_PAIR_USER_DATA:
      return {
        ...state,
        pairUserData: {
          ...state.pairUserData,
          [action.payload.pair]: {
            ...state.pairUserData?.[action.payload.pair],
            ...action.payload.data,
          },
        },
      };

    case SET_ORDER_FORM_PAIR_DATA:
      return {
        ...state,
        orderFormData: {
          ...state.orderFormData,
          ...action.payload.data,
        },
      };
    default:
      return state;
  }
};
